export const css = {
	root: '_22EqZSss',
	' _key': 'ascm-theme/ascm/variants/cpim'
};

export default css;
